/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IErrorMessage, NestedErrorMessage } from "@advapacs/common";
import { UserSettingNotification } from "./operators";

export interface ISessions {
  id: string;
  ip: string;
  location: string;
  device: string;
  createdAt: string;
  current: boolean;
}

const initialState = {
  loading: false,
  errorMessage: null as IErrorMessage | NestedErrorMessage,
  updatedPassword: false,
  notificationSettings: null as UserSettingNotification | null,
  updated: false,
  sessions: [] as Array<ISessions>,
};

const profileSlice = createSlice({
  name: "profileSlice",
  initialState,
  reducers: {
    clearData(state) {
      state.loading = false;
      state.errorMessage = null;
      state.sessions = [];
      state.updatedPassword = false;
    },
    clearError(state) {
      state.errorMessage = null;
    },
    updatePasswordStart(state) {
      state.loading = true;
      state.updatedPassword = false;
    },
    updatePasswordSuccess(state) {
      state.loading = false;
      state.updatedPassword = true;
    },
    updatePasswordFail(state, action: PayloadAction<IErrorMessage>) {
      state.loading = false;
      state.errorMessage = action.payload;
      state.updatedPassword = false;
    },
    getUserSettingNotificationStart(state) {
      state.loading = true;
      state.updated = false;
    },
    getUserSettingNotificationSuccess(
      state,
      action: PayloadAction<UserSettingNotification>
    ) {
      state.loading = false;
      state.notificationSettings = action.payload;
    },
    getUserSettingNotificationFail(
      state,
      action: PayloadAction<IErrorMessage>
    ) {
      state.loading = false;
      state.errorMessage = action.payload;
    },
    updateUserSettingNotificationStart(state) {
      state.loading = true;
      state.updated = false;
    },
    updateUserSettingNotificationSuccess(state) {
      state.loading = false;
      state.updated = true;
    },
    updateUserSettingNotificationFail(
      state,
      action: PayloadAction<IErrorMessage>
    ) {
      state.loading = false;
      state.errorMessage = action.payload;
      state.updated = false;
    },
    getActiveSessionsStart(state) {
      state.loading = true;
    },
    getActiveSessionsSuccess(state, action: PayloadAction<Array<ISessions>>) {
      state.loading = false;
      state.sessions = action.payload;
    },
    getActiveSessionsFail(state) {
      state.loading = false;
      state.sessions = [];
    },
  },
});

export const ProfileAction = profileSlice.actions;
export default profileSlice.reducer;
